import Cookies from 'cookies-js';
import getUUID from '../../getUUID';

export default function setSessionIdCookies() {
  if (!Cookies.get('session-id')) {
    Cookies.set('session-id', getUUID(), {
      path: '/'
    });
  }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/setSessionIdCookies.js
 **/